import { render } from "./all-kategori.vue?vue&type=template&id=193dd781"
import script from "./all-kategori.vue?vue&type=script&lang=js"
export * from "./all-kategori.vue?vue&type=script&lang=js"

import "./all-kategori.vue?vue&type=style&index=0&id=193dd781&lang=css"

import exportComponent from "/home/alfahuma/manual_build/digita-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__